export enum variantOptions {
  "" = "",
  purple = "purple",
  yellow = "yellow",
  green = "green",
}
